import { ViewChild } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ScrBaseComponent } from 'src/app/components/base.component';
import { NewPasswordRequest } from 'src/app/models/account.model';
import { User } from 'src/app/models/user.model';
import { ScrAuthenticationService } from 'src/app/services/authentication.service';
import { UserService } from 'src/app/services/user.service';
import { Message } from 'src/app/shared/messages/messages.component';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent extends ScrBaseComponent implements OnInit {

  model: NewPasswordRequest = new NewPasswordRequest();
  @ViewChild('newPasswordForm', { static: false }) newPasswordForm!: NgForm;
  userId?: string;
  userProfile: User = {} as User;
  public confirmPasswordFocused = false;
  public newPasswordFocused = false;
  public dummy: { password?: string } = { password: ''};
  constructor(private authenticateService: ScrAuthenticationService,
    private userService: UserService) {
    super();
   }

  ngOnInit(): void {
    this.observe(this.userService.getUserProfile(), res => {
      this.userProfile = res.user;
      return false;
    });
  }

  focusConfirmPassword() {
    this.confirmPasswordFocused = false;
  }

  blurConfirmPassword() {
    this.confirmPasswordFocused = true;
  }

  focusNewPassword() {
    this.newPasswordFocused = false;
  }

  blurNewPassword() {
    this.newPasswordFocused = true;
  }

  submitPassword() {

    if (!this.newPasswordForm.form.valid) {
      this.scrollToFirstError();
      return;
    }
    this.authenticateService.getAccessToken().then(val => {
      this.model.accessToken = val as string;

      this.observe(this.authenticateService.changePassword(this.model), res => {
        if (res.messages){
          const m = this.getFirstMessage(res);
          this.displaySuccess(new Message('', m));
          this.newPasswordForm.resetForm();
        }

      });
    }).catch(err => {
      this.log.error(err);
    });

  }

  passwordResult(): string {
    const password = this.dummy.password || '';

    const long = (s: string) => s.length > 8;
    const containsUpper = (s: string) => !!s.match(/[A-Z]/);

    if (long(password)) {return containsUpper(password) ? 'strong' : 'fair'; }
    else { return containsUpper(password) ? 'fair' : 'weak'; }

  }

  



}


